import React from 'react';
import { formatCurrency } from '../../utils/currencyFormatter';
import { PackageIcon, FileTextIcon, TicketIcon, UsersIcon, CalendarIcon, AlertTriangleIcon, ArrowRightIcon } from 'lucide-react';
export function LicenseDashboard({
  locale,
  onNavigate
}) {
  // Mock data for the dashboard
  const summaryData = {
    totalModules: 8,
    activeModules: 6,
    volumeUsage: {
      current: 75420,
      limit: 100000,
      metric: 'Documents',
      percentage: 75
    },
    occasionalPasses: {
      remaining: 42,
      used: 18,
      total: 60
    },
    activeSessions: 14,
    renewalDue: 45
  };
  const alerts = [{
    id: 'alert-1',
    type: 'warning',
    message: 'Vendor Management module license expires in 7 days',
    action: 'Renew Now',
    module: {
      id: 'module-2',
      name: 'Vendor Management'
    }
  }, {
    id: 'alert-2',
    type: 'danger',
    message: 'Document volume usage at 75% of limit',
    action: 'Upgrade Plan',
    plan: {
      id: 'plan-1',
      name: 'Enterprise Document Plan'
    }
  }];
  return <div className="space-y-6" data-id="element-17604">
      {/* Summary Cards */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5" data-id="element-17605">
        {/* Licensed Modules */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-17606">
          <div className="px-4 py-5 sm:p-6" data-id="element-17607">
            <div className="flex items-center" data-id="element-17608">
              <div className="flex-shrink-0 bg-indigo-100 rounded-md p-3" data-id="element-17609">
                <PackageIcon className="h-6 w-6 text-indigo-600" data-id="element-17610" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-17611">
                <dl data-id="element-17612">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-17613">
                    Licensed Modules
                  </dt>
                  <dd data-id="element-17614">
                    <div className="text-lg font-medium text-gray-900" data-id="element-17615">
                      {summaryData.activeModules} / {summaryData.totalModules}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-17616">
              <button type="button" onClick={() => onNavigate('modules')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-17617">
                View all modules
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-17618" />
              </button>
            </div>
          </div>
        </div>
        {/* Volume Usage */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-17619">
          <div className="px-4 py-5 sm:p-6" data-id="element-17620">
            <div className="flex items-center" data-id="element-17621">
              <div className="flex-shrink-0 bg-blue-100 rounded-md p-3" data-id="element-17622">
                <FileTextIcon className="h-6 w-6 text-blue-600" data-id="element-17623" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-17624">
                <dl data-id="element-17625">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-17626">
                    Volume Usage ({summaryData.volumeUsage.metric})
                  </dt>
                  <dd data-id="element-17627">
                    <div className="text-lg font-medium text-gray-900" data-id="element-17628">
                      {summaryData.volumeUsage.current.toLocaleString()} /{' '}
                      {summaryData.volumeUsage.limit.toLocaleString()}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-17629">
              <div className="relative" data-id="element-17630">
                <div className="overflow-hidden h-2 text-xs flex rounded bg-blue-100" data-id="element-17631">
                  <div style={{
                  width: `${summaryData.volumeUsage.percentage}%`
                }} className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-500" data-id="element-17632"></div>
                </div>
                <div className="text-xs text-gray-500 mt-1 text-right" data-id="element-17633">
                  {summaryData.volumeUsage.percentage}% used
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Occasional Passes */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-17634">
          <div className="px-4 py-5 sm:p-6" data-id="element-17635">
            <div className="flex items-center" data-id="element-17636">
              <div className="flex-shrink-0 bg-green-100 rounded-md p-3" data-id="element-17637">
                <TicketIcon className="h-6 w-6 text-green-600" data-id="element-17638" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-17639">
                <dl data-id="element-17640">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-17641">
                    Occasional Passes
                  </dt>
                  <dd data-id="element-17642">
                    <div className="text-lg font-medium text-gray-900" data-id="element-17643">
                      {summaryData.occasionalPasses.remaining} remaining
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-17644">
              <button type="button" onClick={() => onNavigate('passes')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-17645">
                Manage passes
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-17646" />
              </button>
            </div>
          </div>
        </div>
        {/* Active Sessions */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-17647">
          <div className="px-4 py-5 sm:p-6" data-id="element-17648">
            <div className="flex items-center" data-id="element-17649">
              <div className="flex-shrink-0 bg-purple-100 rounded-md p-3" data-id="element-17650">
                <UsersIcon className="h-6 w-6 text-purple-600" data-id="element-17651" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-17652">
                <dl data-id="element-17653">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-17654">
                    Active Sessions
                  </dt>
                  <dd data-id="element-17655">
                    <div className="text-lg font-medium text-gray-900" data-id="element-17656">
                      {summaryData.activeSessions} today
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-17657">
              <button type="button" onClick={() => onNavigate('usage')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-17658">
                View usage details
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-17659" />
              </button>
            </div>
          </div>
        </div>
        {/* Renewal Due */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-17660">
          <div className="px-4 py-5 sm:p-6" data-id="element-17661">
            <div className="flex items-center" data-id="element-17662">
              <div className="flex-shrink-0 bg-yellow-100 rounded-md p-3" data-id="element-17663">
                <CalendarIcon className="h-6 w-6 text-yellow-600" data-id="element-17664" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-17665">
                <dl data-id="element-17666">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-17667">
                    Next Renewal
                  </dt>
                  <dd data-id="element-17668">
                    <div className="text-lg font-medium text-gray-900" data-id="element-17669">
                      {summaryData.renewalDue} days
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-17670">
              <button type="button" onClick={() => onNavigate('modules')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-17671">
                View renewals
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-17672" />
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Alerts */}
      <div className="bg-white shadow sm:rounded-lg" data-id="element-17673">
        <div className="px-4 py-5 sm:px-6" data-id="element-17674">
          <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-17675">
            License Alerts
          </h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-17676">
            Important notifications about your licenses and usage
          </p>
        </div>
        <div className="border-t border-gray-200" data-id="element-17677">
          <div className="divide-y divide-gray-200" data-id="element-17678">
            {alerts.map(alert => <div key={alert.id} className="px-4 py-4 sm:px-6" data-id="element-17679">
                <div className="flex items-start" data-id="element-17680">
                  <div className={`flex-shrink-0 ${alert.type === 'warning' ? 'text-yellow-400' : 'text-red-400'}`} data-id="element-17681">
                    <AlertTriangleIcon className="h-5 w-5" data-id="element-17682" />
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5" data-id="element-17683">
                    <p className="text-sm font-medium text-gray-900" data-id="element-17684">
                      {alert.message}
                    </p>
                    <div className="mt-3 flex" data-id="element-17685">
                      <button type="button" className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={() => {
                    if (alert.module) {
                      onNavigate('module-detail', alert.module);
                    } else if (alert.plan) {
                      onNavigate('plan-detail', alert.plan);
                    }
                  }} data-id="element-17686">
                        {alert.action}
                      </button>
                    </div>
                  </div>
                </div>
              </div>)}
            {alerts.length === 0 && <div className="px-4 py-5 sm:px-6 text-center text-sm text-gray-500" data-id="element-17687">
                No alerts at this time. All licenses are in good standing.
              </div>}
          </div>
        </div>
      </div>
    </div>;
}